import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import moment from "moment";
import { Tooltip } from "@mui/material";
import viewTable from "../../../../../assets/icons/viewTable.svg";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import addREC from "../../../../../assets/icons/addREC.svg";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import deleteRedIcons from "../../../../../assets/icons/delete-red.svg";
import ActionsIcon from "../../../../../assets/icons/actionsIcon.svg";
import CompanyDashboardInitiativeIssueAddPopup from "./company-dashboard-initiative-drawer-issue-add-popup/company-dashboard-initiative-drawer-issue-add-popup";
import CompanyDashboardInitiativeDrawerViewIssue from "./company-dashboard-initiative-drawer-view-issue/company-dashboard-initiative-drawer-view-issue";
import DeleteConfirmationPopup from "../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import { deleteIssueRiskByID } from "../../../../../api/issue-risk";
import Status from "../../../../request-dashboard/request/status/status";
import "./company-dashboard-initiative-add-drawer-issue.scss";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import MODULES from "../../../../../constants/modules";

const ITEM_HEIGHT = 48;

const CompanyDashboardInitiativeAddIssue = (props: any) => {
  const {
    initiativeId,
    initiativeAPIData,
    employeesList,
    fetchInitiativeById,
    setAlertType,
    setAlertOpen,
    setLoading,
    setAlertMessage,
    initiativeDataPermissions,
  } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);
  const [addPopupTitle, setAddPopupTitle] = useState("");
  const [isOpenViewPopup, setIsOpenViewPopup] = useState(false);
  const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);
  const [deletePopupId, setDeletePopupId] = useState<number | null>(null);
  const [editData, setEditData] = useState<any>(null);
  const [issueData, setIssueData] = useState([]);

  const { canRead, canWrite, canEdit, canDelete } = usePermissions(
    MODULES.INITIATIVES,
  );

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const handleOpenAddPopup = () => {
    setIsOpenAddPopup(true);
    setAddPopupTitle("Add Risks/Issue");
  };

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
    setEditData(null);
    setAddPopupTitle("");
  };

  const handleOpenViewPopup = () => setIsOpenViewPopup(true);
  const handleCloseViewPopup = () => setIsOpenViewPopup(false);

  const handleOpenEditPopup = (data: any) => {
    setIsOpenAddPopup(true);
    setEditData(data);
    setAddPopupTitle("Edit Risks/Issues");
    handleClose();
  };

  const handleOpenDeletePopup = (data: any) => {
    setDeletePopupOpen(true);
    setIsOpenViewPopup(false);
    setDeletePopupId(data?.id);
    handleClose();
  };

  const deleteIssueRisk = async () => {
    if (!deletePopupId) return;
    setLoading(true);
    try {
      await deleteIssueRiskByID(deletePopupId);
      fetchInitiativeById();
      setAlertMessage("Issue Risk deleted successfully");
      setAlertType("success");
      setAlertOpen(true);
    } catch {
      setAlertMessage("Failed to delete Issue Risk");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setDeletePopupOpen(false);
      setDeletePopupId(null);
    }
  };

  useEffect(() => {
    if (initiativeAPIData) {
      setIssueData(
        initiativeAPIData?.openRisks?.map((item: any) => ({
          id: item.riskId,
          asOf: item.dateOpened,
          openedBy: item.openedBy,
          description: item.description,
          mitigationPlan: item.mitigationPlan,
          status: item.status || "In Progress",
        })) || [],
      );
      setDeletePopupOpen(false);
      setDeletePopupId(null);
      setLoading(false);
      setIsOpenAddPopup(false);
      setEditData(null);
      setSelectedItem(null);
    }
  }, [initiativeAPIData]);

  const options = [
    ...(canEdit && initiativeDataPermissions
      ? [{ label: "Edit", onClick: handleOpenEditPopup, icon: editIcons }]
      : []),
    ...(canDelete && initiativeDataPermissions
      ? [
          {
            label: <div style={{ marginLeft: "5px" }}>Delete</div>,
            onClick: handleOpenDeletePopup,
            icon: deleteRedIcons,
          },
        ]
      : []),
  ];

  if (!canRead) {
    return <div>No access to this section.</div>;
  }

  const openIssues = issueData.filter(
    (item: any) => item?.status !== "Resolved",
  );
  const resolvedIssues = issueData.filter(
    (item: any) => item?.status === "Resolved",
  );

  return (
    <>
      {anchorEl && <div className="menu-overlay"></div>}
      <div
        className="company-dashboard-initiative-drawer-issue"
        style={{
          height: "auto",
        }}
      >
        <div className="company-dashboard-initiative-drawer-issue-header">
          <div>Open Risks/Issues</div>
          <div className="company-dashboard-initiative-drawer-issue-header-actions">
            {resolvedIssues.length > 0 && (
              <button
                style={{
                  border: "none",
                  background: "none",
                  padding: 0,
                }}
                onClick={handleOpenViewPopup}
              >
                <img src={viewTable} style={{ cursor: "pointer" }} alt="view" />
              </button>
            )}

            {canWrite &&
              initiativeDataPermissions &&
              (initiativeId ? (
                <button
                  style={{
                    border: "none",
                    background: "none",
                    padding: 0,
                  }}
                  onClick={handleOpenAddPopup}
                >
                  <img
                    src={addREC}
                    alt="add"
                    className="company-dashboard-initiative-drawer-issue-header-actions-add"
                    style={{ cursor: "pointer", opacity: 1 }}
                  />
                </button>
              ) : (
                <Tooltip title="Please create an Initiative first to create Risks/Issue">
                  <span
                    style={{
                      display: "inline-block",
                      pointerEvents: "auto",
                    }}
                  >
                    <img
                      src={addREC}
                      alt="add"
                      className="company-dashboard-initiative-drawer-issue-header-actions-add"
                      style={{
                        cursor: "not-allowed",
                        opacity: 0.5,
                        pointerEvents: "none",
                      }}
                    />
                  </span>
                </Tooltip>
              ))}
          </div>
        </div>
        <OverlayScrollbarsComponent
          className="company-dashboard-initiative-drawer-issue-content-box"
          options={{
            scrollbars: {
              theme: "os-theme-dark",
              autoHide: "scroll",
              autoHideDelay: 400,
            },
          }}
        >
          {openIssues?.map((data: any, index: number) => (
            <div
              key={index + 1}
              className="company-dashboard-initiative-drawer-issue-content"
            >
              <div className="company-dashboard-initiative-drawer-issue-content-header-action">
                <div className="company-dashboard-initiative-drawer-issue-content-header-action-text">
                  <div className="company-dashboard-initiative-drawer-issue-content-header-action-text-box">
                    As of: <br />
                    <span>
                      {moment(data?.asOf || new Date()).format("MM-DD-YYYY")}
                    </span>
                  </div>
                  <div className="company-dashboard-initiative-drawer-issue-content-header-action-text-box">
                    Opened By: <br />
                    <span>{data?.openedBy || "Unknown"}</span>
                  </div>
                  <div className="company-dashboard-initiative-drawer-issue-content-header-action-button-status">
                    <Status status={data?.status} />
                  </div>
                </div>

                <div className="company-dashboard-initiative-drawer-issue-content-header-action-button">
                  {options.length > 0 && (
                    <>
                      <IconButton
                        aria-label="more"
                        id={`long-button-${data.id}`}
                        aria-controls={
                          open && selectedItem?.id === data.id
                            ? `long-menu-${data.id}`
                            : undefined
                        }
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={(event) => handleClick(event, data)}
                      >
                        <img
                          className="actions-icon"
                          src={ActionsIcon}
                          alt="Actions"
                        />
                      </IconButton>

                      <Menu
                        id={`long-menu-${data.id}`}
                        anchorEl={anchorEl}
                        open={open && selectedItem?.id === data.id}
                        onClose={handleClose}
                        slotProps={{
                          paper: {
                            style: {
                              maxHeight: ITEM_HEIGHT * 4.5,
                              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
                              borderRadius: 16,
                              padding: 0,
                            },
                            sx: {
                              "&.MuiPaper-root": {
                                padding: "0px !important",
                                width: "156px",
                              },
                            },
                          },
                          list: { "aria-labelledby": "long-button" },
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        {options.map((option, idx) => (
                          <MenuItem
                            key={idx + 1}
                            onClick={() => {
                              option.onClick(selectedItem);
                              handleClose();
                            }}
                            sx={{ padding: "8px 16px !important" }}
                          >
                            {React.isValidElement(option.icon) ? (
                              <span style={{ marginRight: 8 }}>
                                {option.icon}
                              </span>
                            ) : (
                              <img
                                src={option.icon}
                                alt={
                                  typeof option.label === "string"
                                    ? option.label
                                    : "action"
                                }
                                style={{ marginRight: 8 }}
                              />
                            )}
                            {option.label}
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )}
                </div>
              </div>

              <div className="company-dashboard-initiative-drawer-issue-content-main">
                <div className="company-dashboard-initiative-drawer-issue-content-main-text">
                  Description
                </div>
                <div className="company-dashboard-initiative-drawer-issue-content-main-sub">
                  {data?.description || "No description available"}
                </div>
              </div>

              <div className="company-dashboard-initiative-drawer-issue-content-main">
                <div className="company-dashboard-initiative-drawer-issue-content-main-text">
                  Mitigation Plan
                </div>
                <div className="company-dashboard-initiative-drawer-issue-content-main-sub">
                  {data?.mitigationPlan || "No Mitigation Plan available"}
                </div>
              </div>
            </div>
          ))}
        </OverlayScrollbarsComponent>
        <CompanyDashboardInitiativeIssueAddPopup
          isOpenAddPopup={isOpenAddPopup}
          onCancel={handleCloseAddPopup}
          addPopupTitle={addPopupTitle}
          issueData={issueData}
          setIssueData={setIssueData}
          setEditData={setEditData}
          editData={editData}
          initiativeId={initiativeId}
          initiativeAPIData={initiativeAPIData}
          employeesList={employeesList}
          fetchInitiativeById={fetchInitiativeById}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
        />

        <CompanyDashboardInitiativeDrawerViewIssue
          isOpenViewPopup={isOpenViewPopup}
          onCancel={handleCloseViewPopup}
          options={options}
          issueData={issueData}
          initiativeDataPermissions={initiativeDataPermissions}
        />

        {isDeletePopupOpen && (
          <DeleteConfirmationPopup
            isOpen={true}
            onClose={() => {
              setDeletePopupOpen(false);
              setDeletePopupId(null);
            }}
            handleDelete={deleteIssueRisk}
            deleteId={null}
          />
        )}
      </div>
    </>
  );
};

export default CompanyDashboardInitiativeAddIssue;
